import * as react_components from "../reactcomponent.js"
import * as utility from "../services.js"
import * as propertyTypes from "../property_types.js"
import * as datasources from "../common_metadata/datasource.js"
import { DrillDown, PlotBand, Tooltip } from "../statistic_components/common_metadata.js"
import { ErrorBoundary } from "../components/error_boundary.js"
import { Button } from "../../core/components/button.js";
import React from "react"
interface KendoChartProps {
    uid: any;
    values: any;
    queryParameter: any;
    onTextChange(propertyName, value): any;
    context: utility.IContextProps;
    rootPropertyPath: any;
    extendedUid: string;
    metadataSettings: ChartState;
    settings: any;
}

export class KendoChart extends React.Component<KendoChartProps, { showExportDialog?: boolean, values?: any[], page, allValues?: any[] }>{

    constructor(props: utility.IComponentProps, context: any) {
        super(props, context);
        this.state = { page: 0 };
    }

    handleDataChanged = (data, p1, p2, allData) => {
        this.setState({ values: data, allValues: allData });
    }

    createExportButton() {
        var url = this.props.settings.exportUrl;
        if (!url || !this.state.values) {
            return null;
        }
        else {
            var root = "";

            var url: any = root + url + "?";
            var newParams = $.extend({}, this.props.queryParameter);
            newParams.__templateName = this.props.settings.exportTemplate;

            url += $.param(newParams);
            return (
                <div className="btn-group">
                    <button type="button" className="btn btn-success dropdown-toggle no-print" data-toggle="dropdown">
                        Export <span className="caret"></span>
                    </button>
                    <ul className="dropdown-menu" role="menu">
                        <li><a href={url}>Excel</a></li>
                    </ul>
                </div>);
        }
    }

    handleSeriesClick = (e) => {

        if (this.props.settings.drilldown && (this.props.settings.drilldown.statisticId) && this.props.settings.drilldown.statisticId != "") {
            var newObj: any = $.extend({}, this.props.queryParameter);
            newObj[this.props.settings.drilldown.destField] = e.dataItem[this.props.settings.drilldown.sourceField];
            newObj._hideInputControls = this.props.settings.drilldown.hideInputControls;
            var params = newObj;
            this.props.context.drillDownObject.requestDrillDown(params, this.props.settings.drilldown.statisticId, e.dataItem);
        }
    }

    private fixValueAxes(chartSettings: any) {
        if (chartSettings.valueAxes && chartSettings.valueAxes.length > 0) {
            for (var i = 0; i < chartSettings.valueAxes.length; i++) {
                const valueAxe = chartSettings.valueAxes[i];
                valueAxe.min = valueAxe.min ? Number(valueAxe.min) : null;
                valueAxe.max = valueAxe.max ? Number(valueAxe.max) : null;
            }
        }
    }


    render() {
        const maxValueField = this.props.settings.maxValueField;
        const minValueField = this.props.settings.minValueField;

        let minMax = null;
        if (maxValueField && this.state.values && this.state.values.length > 0 && this.state.values[0][maxValueField]) {
            minMax = minMax || {}
            minMax.max = this.state.values[0][maxValueField];
        }

        if (minValueField && this.state.values && this.state.values[minValueField]) {
            minMax = minMax || {}
            minMax.min = this.state.values[0][minValueField];
        }
        let plotBands;
        let chartSettings = this.props.settings.chartSettings;

        if (chartSettings) {
            plotBands = this.props.settings.chartSettings.plotBands;

            if (minMax || (plotBands && plotBands.length > 0)) {
                let valueAxis = minMax || {};
                if (plotBands && plotBands.length > 0) {
                    valueAxis.plotBands = plotBands;
                }
                chartSettings.valueAxis = valueAxis;
            }
            else {
                chartSettings.valueAxis = null;
            }
        }
        this.fixValueAxes(chartSettings)
        const pageSize = Number(this.props.settings.pageSize || 10);
        const exportButton = <Button handleClick={() => this.setState({ showExportDialog: true })} iconName="file-export"></Button>
        return (
            <>
                {this.state.showExportDialog ? <ChartExportDialog
                    pageSize={pageSize}
                    chartSettings={chartSettings}
                    height={this.props.settings.height}
                    onClose={() => this.setState({ showExportDialog: false })}
                    allvalues={this.state.allValues}
                    values={this.state.values} /> : null}
                <react_components.ReactColumn width={this.props.metadataSettings.width}>
                    <ErrorBoundary>
                        <react_components.ReactDataPager
                            uid={this.props.uid} 
                            dataSource={this.props.metadataSettings.dataSource}
                            dataSourceId={this.props.metadataSettings.dataSource ? this.props.metadataSettings.dataSource.getDataSourceIdentifier() : null}
                            headerContent={exportButton}
                            context={this.props.context}
                            titel={this.props.settings.titel} dataUrl={this.props.settings.dataUrl} enablePagging={true}
                            pageSize={pageSize} queryParameter={this.props.queryParameter}
                            onVisibleDataChange={this.handleDataChanged}>
                            <react_components.KendoSimpleChart settings={chartSettings} values={this.state.values} onSeriesClick={this.handleSeriesClick} height={this.props.settings.height} />
                        </react_components.ReactDataPager>
                    </ErrorBoundary>
                </react_components.ReactColumn>
            </>
        );
    }
};

class ChartExportDialog extends React.Component<{ chartSettings, onClose?, onSave?, height, values: any[], allvalues: any[], pageSize: number }, { pageSize: number, guid: string }>{
    constructor(props) {
        super(props)
        this.state = { pageSize: props.pageSize, guid: kendo.guid() };
    }

    private chartDiv: HTMLElement;
    splitArray = (array, chunkSize: number) => {
        const result = [];
        for (let i = 0; i < array.length; i += chunkSize) {
            result.push(array.slice(i, i + chunkSize));
        }
        return result;
    }
    handleExport = () => {
        // Convert the DOM element to a drawing using kendo.drawing.drawDOM
        kendo.drawing.drawDOM($(this.chartDiv), null)
            .then(function (group) {
                // Render the result as a PDF file
                return kendo.drawing.exportImage(group, {
                    paperSize: "auto",
                    margin: { left: "1cm", top: "1cm", right: "1cm", bottom: "1cm" }
                });
            })
            .done(function (data) {
                kendo.saveAs({
                    dataURI: data,
                    fileName: "chart.png",
                    proxyURL: "https://demos.telerik.com/kendo-ui/service/export"
                });
            });
    }

    generateCharts = () => {
        const arrays = this.splitArray(this.props.allvalues, Number(this.state.pageSize || this.props.pageSize));
        const charts = arrays.map((arr, i) => { return <react_components.KendoSimpleChart key={this.state.guid + "_" + i} settings={this.props.chartSettings} values={arr} height={this.props.height} /> });
        return charts;
    }

    handlePageChanged = (e) => {
        this.setState({ pageSize: e.target.value, guid: kendo.guid() });
    }

    render() {
        return <react_components.BasicDialog
            height="60%"
            width="80%"
            onClose={this.props.onClose}
            title="Export"
            okayLabel="Export"
            onSave={this.handleExport} >
            <div style={{ display: "flex", flexDirection: "column", height: "100%" }}>
                <div>
                    Page size<input value={this.state.pageSize} onChange={this.handlePageChanged}></input>
                </div>
                <div style={{ flex: "1", overflow: "auto" }} >
                    <div ref={(e) => { this.chartDiv = e }} key={this.state.guid}>
                        {this.generateCharts()}
                    </div>
                </div>
            </div>
        </react_components.BasicDialog >
    }
}
export class ChartState extends propertyTypes.BaseComponentProps {
    private heightMetadata = new propertyTypes.TextProperty("height", "Height");
    public height: string;

    private titleMetadata = new propertyTypes.TranslatableTextProperty("titel", "Title");
    public title: string;

    private pageSizeMetadata = new propertyTypes.TextProperty("pageSize", "Page size");
    public pageSize: number;

    public dataSource: datasources.Datasource;

    private maxValueFieldMetadata = new propertyTypes.ColumnProperty("maxValueField", "Max value field", "dataSource");
    public maxValueField: string;

    private minValueFieldMetadata = new propertyTypes.ColumnProperty("minValueField", "Min value field", "dataSource");
    public minValueField: string;

    private chartSettingsMetadata = new propertyTypes.ObjectPropertyExt("chartSettings", "Chart settings")
        .addStateImplementation("chartSettings", ChartSettings);
    public chartSettings: ChartSettings;

    private drilldownMetadata = new propertyTypes.ObjectPropertyExt("drilldown", "Drilldown")
        .addStateImplementation("drillDown", DrillDown);
    public drilldown: DrillDown;

    private chartMetadata: propertyTypes.BaseProperty[];
    constructor() {
        super();
        const baseMetaData = super.getMetadata();
        this.chartMetadata = baseMetaData.concat([this.heightMetadata, this.titleMetadata, this.pageSizeMetadata, datasources.dataSourceMetadata, this.maxValueFieldMetadata, this.minValueFieldMetadata, this.chartSettingsMetadata, this.drilldownMetadata]);
    };

    getMetadata(): propertyTypes.BaseProperty[] {
        return this.chartMetadata;
    }
}



class ChartSettings extends propertyTypes.Serializable {
    private themeMetadata = new propertyTypes.SelectProperty("theme", "Theme").addOption("bootstrap", "Bootstrap").addOption("black", "Black").addOption("silver", "Silver");
    public theme: string;

    private seriesMetadata = new propertyTypes.ObjectListPropertyExt("series", "Series").addStateImplementation("defaultSeries", Series);
    public series: Series[];

    private legendMetadata = new propertyTypes.ObjectPropertyExt("legend", "Legend")
        .addStateImplementation("legend", Legend);
    public legend: Legend

    private labelsMetadata = new propertyTypes.ObjectPropertyExt("labels", "Labels")
        .addStateImplementation("labels", SeriesLabels);
    public labels: SeriesLabels;

    private tooltipMetadata = new propertyTypes.ObjectPropertyExt("tooltip", "Tooltip")
        .addStateImplementation("labels", Tooltip);
    public tooltip: Tooltip;

    private categoryAxisMetadata = new propertyTypes.ObjectPropertyExt("categoryAxis", "Category axis")
        .addStateImplementation("default", CategoryAxis);
    public categoryAxis: CategoryAxis;

    private plotBandMetadata = new propertyTypes.ObjectListPropertyExt("plotBands", "Plot bands").addStateImplementation("defaultPlotBand", PlotBand);
    public plotBands: PlotBand[];

    private valueAxesMetadata = new propertyTypes.ObjectListPropertyExt("valueAxes", "Value axes").addStateImplementation("defaultValueAxes", ValueAxes);
    public valueAxes: ValueAxes[];

    private chartSettingsMetadata: propertyTypes.BaseProperty[];

    constructor() {
        super();
        this.chartSettingsMetadata = [this.themeMetadata, this.seriesMetadata, this.legendMetadata, this.tooltipMetadata, this.categoryAxisMetadata, this.plotBandMetadata, this.valueAxesMetadata];
    }
    getMetadata(): propertyTypes.BaseProperty[] {
        return this.chartSettingsMetadata;
    }
}

class Series extends propertyTypes.Serializable {
    private typeMetadata = new propertyTypes.SelectProperty("type", "Type").addOption("area", "Area").addOption("line", "Line").addOption("bar", "Bar").addOption("column", "Column").addOption("pie", "Pie").addOption("radarLine", "Radar");
    public type: string;

    private styleMetadata = new propertyTypes.SelectProperty("style", "Line style").addOption("smooth", "Smooth").addOption("step", "Step");
    public style: string;

    private fieldMetadata = new propertyTypes.ColumnProperty("field", "Field", "dataSource");
    public field: string;

    private colorFieldMetadata = new propertyTypes.ColumnProperty("colorField", "Color field", "dataSource");
    public colorField: string;

    private colorMetadata = new propertyTypes.TextProperty("color", "Color");
    public color: string;

    private nameMetadata = new propertyTypes.TranslatableTextProperty("name", "Name");
    public name: string;

    private categoryFieldMetadata = new propertyTypes.ColumnProperty("categoryField", "Category field", "dataSource");
    public categoryField: string;

    private stackMetadata = new propertyTypes.ObjectPropertyExt("stack", "Stack")
        .addStateImplementation("stack", Stack);
    public stack: Stack;

    private labelsMetadata = new propertyTypes.ObjectPropertyExt("labels", "Labels")
        .addStateImplementation("stack", SeriesLabels);
    public labels: SeriesLabels;

    private axesMetadata = new propertyTypes.TextProperty("axis", "Axis");
    public axis: string;

    private seriesMetadata: propertyTypes.BaseProperty[];

    constructor() {
        super();
        this.seriesMetadata = [this.typeMetadata, this.styleMetadata, this.fieldMetadata, this.colorFieldMetadata, this.colorMetadata, this.nameMetadata, this.categoryFieldMetadata, this.stackMetadata, this.labelsMetadata, this.axesMetadata];
    }

    getMetadata(): propertyTypes.BaseProperty[] {
        return this.seriesMetadata;
    }
}

class Stack extends propertyTypes.Serializable {
    private groupMetadata = new propertyTypes.TextProperty("group", "Group");
    public group: string;

    private stackMetadata: propertyTypes.BaseProperty[];

    constructor() {
        super();
        this.stackMetadata = [this.groupMetadata];
    }

    getMetadata(): propertyTypes.BaseProperty[] {
        return this.stackMetadata;
    }
}

class SeriesLabels extends propertyTypes.Serializable {
    private rotationMetadata = new propertyTypes.TextProperty("rotation", "Rotation");
    public rotation: string;

    private visibleMetadata = new propertyTypes.CheckBoxProperty("visible", "Visible");
    public visible: boolean;

    private templateMetadata = new propertyTypes.TemplateProperty("template", "Template");
    public template: string;

    private positionMetadata = new propertyTypes.TextProperty("position", "Position");
    public position: string;

    private labelsMetadata: propertyTypes.BaseProperty[];

    constructor() {
        super();
        this.labelsMetadata = [this.rotationMetadata, this.visibleMetadata, this.templateMetadata, this.positionMetadata];
    }

    getMetadata(): propertyTypes.BaseProperty[] {
        return this.labelsMetadata;
    }
}

class Legend extends propertyTypes.Serializable {
    private visibleMetadata = new propertyTypes.CheckBoxProperty("visible", "Visible");
    public visible: boolean;

    private positionMetadata = new propertyTypes.SelectProperty("position", "Position").addOption("left", "Left").addOption("top", "Top").addOption("right", "Right").addOption("bottom", "Bottom");

    private legendMetadata: propertyTypes.BaseProperty[];

    constructor() {
        super();
        this.legendMetadata = [this.visibleMetadata, this.positionMetadata];
    }

    getMetadata(): propertyTypes.BaseProperty[] {
        return this.legendMetadata;
    }
};

class CategoryAxis extends propertyTypes.Serializable {
    private fieldMetadata = new propertyTypes.ColumnProperty("field", "Field", "dataUrl");
    public field: String;

    private labelsMetadata = new propertyTypes.ObjectPropertyExt("labels", "Labels")
        .addStateImplementation("default", CategoryAxisSeriesLabels);

    private categoryAxisMetadata: propertyTypes.BaseProperty[] = [this.fieldMetadata, this.labelsMetadata];
    getMetadata(): propertyTypes.BaseProperty[] {
        return this.categoryAxisMetadata;
    }
}

class CategoryAxisSeriesLabels extends propertyTypes.Serializable {
    private rotationMetadata = new propertyTypes.TextProperty("rotation", "Rotation");
    public rotation: string;

    private visibleMetadata = new propertyTypes.CheckBoxProperty("visible", "Visible");
    public visible: boolean;

    categoryAxisLabelsMetadata: propertyTypes.BaseProperty[] = [this.rotationMetadata, this.visibleMetadata];

    getMetadata(): propertyTypes.BaseProperty[] {
        return this.categoryAxisLabelsMetadata;
    }
}

class ValueAxes extends propertyTypes.Serializable {
    private nameMetadata = new propertyTypes.TextProperty("name", "Name");
    public name: string;

    private titleMetadata = new propertyTypes.ObjectPropertyExt("title", "Title").addStateImplementation("defaultTitle", AxisText);
    public title: string;

    private minMetadata = new propertyTypes.TextProperty("min", "Min");
    public min: string;

    private maxMetadata = new propertyTypes.TextProperty("max", "Max");
    public max: string;

    private valueAxisMetadata: propertyTypes.BaseProperty[];

    constructor() {
        super();
        this.valueAxisMetadata = [this.nameMetadata, this.titleMetadata, this.minMetadata, this.maxMetadata];
    }

    getMetadata(): propertyTypes.BaseProperty[] {
        return this.valueAxisMetadata;
    }
}


class AxisText extends propertyTypes.Serializable {
    private textMetadata = new propertyTypes.TextProperty("text", "Text");
    public text: string;

    axisTextMetadata: propertyTypes.BaseProperty[] = [this.textMetadata];

    getMetadata(): propertyTypes.BaseProperty[] {
        return this.axisTextMetadata;
    }
}